import Config from 'config';

export function buildReportUrl(userId, reportType, fileFormat, timeRange, includeExtendedAuditReport) {
  let commonQueryParams = `&extended=${includeExtendedAuditReport}`;
  let gilaQueryParams = `&gila${commonQueryParams}`;
  let highlanderQueryParams = `&highlander=true${commonQueryParams}`;

  // reportType is the report type
  switch (reportType) {
    case 'activity_report':
      return `${Config.api.host}/api/v2/users/${userId}/activity_report.${fileFormat}`;
    case 'cost_items':
      // The first iteration of highlander only supports csv
      if (fileFormat.toLowerCase() == 'csv') {
        return `${Config.api.host}/user_reports/${userId}/${reportType}.${fileFormat}${timeRange}${highlanderQueryParams}`;
      }
  }
  return `${Config.api.host}/user_reports/${userId}/${reportType}.${fileFormat}${timeRange}${gilaQueryParams}`;
}



// WEBPACK FOOTER //
// ./src/lib/report-utils.js